// extracted by mini-css-extract-plugin
export default {"container":"Eq-z","ratingLayout":"Fq-z","ratingLabel":"Gq-z","nonInteractiveRatingLabel":"Hq-z"};